import {SensitivityParams} from "../../fund/models/sensitivity-params";
import {DealSensitivityReturnSummary} from "./deal-sensitivity-return-summary";
import {AggregatedDealCashflows} from "./aggregated-deal-cashflows";

export interface DealSensitivity {
    id?: number;
    dealRevId?: number;
    name?: string;
    createdByName?: string;
    custom?: boolean;
    sensitivityParams?: SensitivityParams;
    sensitivityReturnSummary?: DealSensitivityReturnSummary;
    aggregatedDealCashflowsLow?: AggregatedDealCashflows;
    aggregatedDealCashflowsBase?: AggregatedDealCashflows;
    aggregatedDealCashflowsHigh?: AggregatedDealCashflows;
    aggregatedDealCashflowsWeighted?: AggregatedDealCashflows;
    clientErrorMessage?: string;
    errorCode?: string;
}

export const EMPTY_DEAL_SENSITIVITY: DealSensitivity = {
    id: undefined,
    dealRevId: undefined,
    name: undefined,
    createdByName: undefined,
    custom: undefined,
    sensitivityParams: undefined,
    sensitivityReturnSummary: undefined,
    aggregatedDealCashflowsLow: undefined,
    aggregatedDealCashflowsBase: undefined,
    aggregatedDealCashflowsHigh: undefined,
    aggregatedDealCashflowsWeighted: undefined,
    clientErrorMessage: undefined,
    errorCode: undefined,
};
